import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./AboutUsIntro.css";
import { useNavigate } from "react-router-dom";

const AboutUsIntro = () => {
  const sectionRef = useRef(null);
  const navigate = useNavigate();
  const isInView = useInView(sectionRef, {
    margin: "-100px 0px -100px 0px",
    once: false,
  });

  return (
    <section ref={sectionRef} className="about-us-intro-section">
      <motion.div
        className="about-us-intro-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: isInView ? 1 : 0 }}
        transition={{ duration: 0.7 }}
      >
        {/* Top */}
        <div className="about-company-info">
          <h1 className="about-heading">
            At NeridTech, we are leaders in ASIC design &amp; verification.  
            Leveraging industry-proven methodologies and state-of-the-art tools,  
            we deliver RTL development, IP integration, UVM-based testbenches,  
            formal property checking and full-chip sign-off services.
          </h1>
        </div>

        {/* Bottom */}
        <div className="about-columns">
          <div className="about-column left-column">
            <h2>Our Expertise</h2>
            <p>
              From front-end RTL coding through power-aware synthesis and timing  
              closure, our design team crafts robust, high-performance ASICs.  
              Our verification experts then validate every corner-case—ensuring  
              your silicon works perfectly from day one.
            </p>
            <button className="about-button"  onClick={() => navigate("/services")}>
              Learn More
            </button>
          </div>
          <div className="about-column right-column">
            <h2>Join Our Team</h2>
            <p>
              Passionate about semiconductors? We’re always looking for talented  
              RTL designers, verification engineers, and system architects.  
              Grow your career with challenging projects and a world-class team.
            </p>
            <button className="about-button" onClick={() => navigate("/careers/job-openings")}>
              Careers <span className="arrow-symbol">▾</span>
            </button>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default AboutUsIntro;